
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TopBannerSection',
  props: {
    images: {
      type: Array,
      required: true,
      default: () => []
    },
    loaded: {
      required: true,
      type: Boolean,
      default: false
    }
  }
  // mounted() {
  //   this.calculateImg();
  // },
  // created() {
  //   this.$bus.$on('calculate-img', this.calculateImg);
  // },
  // methods: {
  //   calculateImg() {
  //     const imgs: any[] = Array.from(
  //       document.querySelectorAll('.top-img-container')
  //     );

  //     imgs.forEach(e => {
  //       e.style.height = `${window.innerWidth / 2}px`;
  //     });
  //   }
  // }
});
